export const EXTRACTION_BUSINESSRULES = 'Extraction-BusinessRules';
export const PRELIMINARY_CATALOG = 'Preliminary-Catalog';
export const CHECKLIST = 'Checklist';
export const DATAMODELLIST = 'DatamodelList';
